export default {
  // 备忘录
  utils: {
    plus: '加',
    reduce: '减',
    ride: '乘',
    except: '除',
    Involution: '乘方',
    leftBrackets: '左括号',
    lrightBrackets: '右括号',
    chuanLian: '串联',
    dengyu: '等于',
    budengyu: '不等于',
    dayu: '大于',
    xiaoyu: '小于',
    dayudengyu: '大于或等于',
    xiaoyugengyu: '小于或等于',
    dataAndTime: '日期和时间',
    example: '示例',
    formulaInfo1: '返回指定日期字段中年份的正数',
    formulaInfo2: '返回指定日期字段中月份的正数',
    formulaInfo24: '返回指定日期字段中某月的天数',
    formulaInfo3: '返回表示当前时刻的日期时间',
    formulaInfo4: '返回表示当前时刻的日期',
    formulaInfo5: '返回两个日期之间的天数。 Y:年、M:月、D:日、H:时、N:分、S:秒',
    formulaInfo6:
      '在向指定日期加上一段时间的基础上, 返回新的 datetime 值; Y:年、M:月、D:日、H:时、N:分、S:秒',
    formulaInfo7: '返回两个日期之间的时间, Y:年、M:月、D:日',
    formulaInfo42: "未联系天数=EXTRACT('D','current_date',2017-12-25), 实时计算结果值",
    formulaInfo44: '返回两个日期之间的时间 Y:年、M:月、D:日、H:时、N:分、S:秒',
    formulaInfo45: "时长=EXTRACT('H','current_timestamp',2017-12-25 20:15:00)，实时计算结果值",
    formulaInfo8: '通过年、月、日创建日期',
    number: '数字',
    formulaInfo9: '返回数值的绝对值(不含正负号的数字)',
    formulaInfo46: '将小写数字转换成中文大写',
    logic: '逻辑',
    formulaInfo10:
      '如果条件满足(布尔表达式返回 TRUE 时), 则在 IF 关键字及其条件之后执行 语句; 可选的 ELSE 关键字引入备用的 语句，当不满足 IF 条件时，就执行这个(ELSE)语句',
    formulaInfo11:
      "IF 分数==100 THEN 'AA' ELSE IF 分数>=90 THEN 'A' ELSE IF 分数>=80 THEN 'B' ELSE IF 分数>=70 THEN 'C' ELSE IF 分数>=60 THEN 'D' ELSE 'F' END",
    formulaInfo12:
      '确定表达式是否为空(空白), 如果是则返回 TRUE(真); 如果它包含一个值，则该函数返回 FALSE(假)',
    formulaInfo13:
      'ISNULL(订单.总金额,0)若订单.总金额不为NULL则显示订单.总金额，若为NULL则显示逗号后面的0',
    formulaInfo14: '检查是否所有参数均为真, 如果所有参数均为真则返回TRUE',
    formulaInfo15: '检查表达式是否具有值,如果没有值则发返回TRUE',
    formulaInfo16: '反函数, 用户来确保一个值不等于某一个特定的值',
    formulaInfo17: "IF NOT(年龄>=18) THEN '未成年，不能进入游戏' END",
    formulaInfo18: '文本值为数字时，返回TRUE，反之FALSE',
    formulaInfo19: '检查任一参数是否为真, 如果有一个参数为真则返回TRUE',
    formulaInfo20: '检查text是否包含compare_text，如果是则返回TRUE',
    formulaInfo21: "CONTAINS(客户地址,'深圳市')=TRUE",
    formulaInfo22: '如果文本与正则表达式regex_text相匹配，则返回TRUE',
    formulaInfo23: "REGEX(手机,'^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$)')",
    text: '文本',
    formulaInfo25: '返回从文本字符串开头算起的指定数量的字符',
    formulaInfo26: '返回指定的文本字符串中所含的字符数',
    formulaInfo27: '返回从文本字符串右边算起的指定数量的字符',
    formulaInfo28: '将一个值转换为使用标准显示格式的文本',
    formulaInfo29: '将文本字符串转换为数字类型',
    formulaInfo30: '给定字符串的起始位置和长度, 返回字符串中间的字符',
    formulaInfo31: '检查文本是否以特定字符开头, 如果是则返回TRUE，否则返回FALSE',
    formulaInfo43: "BEGINS(会员卡号,'801')",
    summary: '汇总',
    formulaInfo32: '返回组中的各项项数',
    formulaInfo33: 'COUNT(产品.产品编号) 返回组中的项数',
    formulaInfo34: '返回组中各项的和。',
    formulaInfo35: '客户成交总金额=SUM(合同.总金额)',
    formulaInfo36: '返回一系列数字中的最小数字',
    formulaInfo37: '学员最低成绩=MIN(成绩.分数)',
    formulaInfo38: '返回一系列数字中的最大数字',
    formulaInfo39: '学员最低成绩=MAN(成绩.分数)',
    formulaInfo40: '返回组中的平均值',
    formulaInfo41: '会员平均消费=AVG(销售订单.金额)',
    noPicture: '无图',
    xiuxian: '休闲',
    relax: '轻松',
    business: '商务',
    hezuo: '合作',
    meeting: '会议',
    up: '向上',
    administration: '行政',
    quwei: '趣味',
    silent: '寂静',
    dushi: '都市',
    qinliang: '清凉',
    menghuan: '梦幻',
    richu: '日出',
    chuxia: '初夏',
    reqing: '热情',
    yaoyuan: '遥远',
    shenye: '夜深',
    work: '工作',
    B2cPlatform: '电商平台',
    ITInternet: 'IT互联网',
    teachTrain: '教育培训',
    houseCenter: '房产中介',
    jinrongBaoxian: '金融保险',
    wuliuYunshu: '物流运输',
    jiazhengFuwu: '家政服务',
    qicheFuwu: '汽车服务',
    yiliaoZhiyao: '医疗制药',
    lvshiAnjian: '律师案件',
    nonglinye: '农林牧渔业',
    guangaoMeiti: '广告媒体',
    other: '其他',
    xingzhengBangong: '行政办公',
    renliZiyuan: '人力资源',
    kehuGuanli: '客户管理',
    huiyuanGuanli: '会员管理',
    shouhouGuanli: '售后管理',
    jinxiaocun: '进销存',
    cangkuGuanli: '仓储管理',
    subMenu: '子菜单',
    view: '视图',
    chart: '图表',
    taskYongdaotu: '任务泳道图',
    logOutOfDate: '登录过期',
    networkExceptionTryAgain: '网络异常, 请稍候重试',
    browserDontSupportCanvas: '您的浏览器版本不支持canvas',
    pwdRuleInfo1: '不符合密码最小长度',
    pwdRuleInfo2: '需包含字母和数字字符',
    pwdRuleInfo3: '需包含字母、数字和特殊字符',
    pwdRuleInfo4: '需包含数字和大小写字母',
    pwdRuleInfo5: '需包含数字、大小写字母和特殊字符',
    listChart: '列表式',
    summaryChart: '汇总式',
    matrixChart: '矩阵式',
    barChart: '柱状图',
    stackChart: '堆叠柱状图',
    stripChart: '条形图',
    stackStripChart: '堆叠条形图',
    areachart: '面积图',
    scatterChart: '散点图',
    linechart: '折线图',
    pie1Chart: '饼图1',
    pie2Chart: '饼图2',
    ringChart: '环形图',
    funnelChart: '漏斗图',
    mapChart: '地图',
    gaugeChart: '仪表图',
    valueNum: '数值1',
    valueSvg: '数值2',
    radarChart1: '雷达图1',
    radarChart2: '雷达图2',
    ganttChart: '甘特图',
    dimensionValue1: '1个或多个维度，1个或多个数值',
    dimensionValue2: '1个或2个维度，1-3个数值',
    dimensionValue3: '1个维度，1个数值',
    dimensionValue4: '1个数值',
    dimensionValue5: '1个维度(省市区组件)，1个数值',
    dimensionValue6: '1个维度，1个或多个数值',
    dimensionValue7: '1-3个维度，1个或多个数值',
    selectEmoji: '选择表情',
    emoji1: '[呲牙]',
    emoji2: '[调皮]',
    emoji3: '[汗]',
    emoji4: '[偷笑]',
    emoji5: '[拜拜]',
    emoji6: '[打你]',
    emoji7: '[擦汗]',
    emoji8: '[猪头]',
    emoji9: '[玫瑰]',
    emoji10: '[流泪]',
    emoji11: '[快哭了]',
    emoji12: '[嘘]',
    emoji13: '[酷]',
    emoji14: '[抓狂]',
    emoji15: '[委屈]',
    emoji16: '[屎]',
    emoji17: '[炸弹]',
    emoji18: '[菜刀]',
    emoji19: '[可爱]',
    emoji20: '[色]',
    emoji21: '[害羞]',
    emoji22: '[得意]',
    emoji23: '[吐]',
    emoji24: '[微笑]',
    emoji25: '[发火]',
    emoji26: '[尴尬]',
    emoji27: '[惊恐]',
    emoji28: '[冷汗]',
    emoji29: '[心]',
    emoji30: '[嘴唇]',
    emoji31: '[白眼]',
    emoji32: '[傲慢]',
    emoji33: '[难过]',
    emoji34: '[惊讶]',
    emoji35: '[疑问]',
    emoji36: '[睡]',
    emoji37: '[亲亲]',
    emoji38: '[憨笑]',
    emoji39: '[爱情]',
    emoji40: '[衰]',
    emoji41: '[撇嘴]',
    emoji42: '[奸笑]',
    emoji43: '[奋斗]',
    emoji44: '[发呆]',
    emoji45: '[右哼哼]',
    emoji46: '[抱抱]',
    emoji47: '[坏笑]',
    emoji48: '[企鹅亲]',
    emoji49: '[鄙视]',
    emoji50: '[晕]',
    emoji51: '[大兵]',
    emoji52: '[拜托]',
    emoji53: '[强]',
    emoji54: '[垃圾]',
    emoji55: '[握手]',
    emoji56: '[胜利]',
    emoji57: '[抱拳]',
    emoji58: '[枯萎]',
    emoji59: '[米饭]',
    emoji60: '[蛋糕]',
    emoji61: '[西瓜]',
    emoji62: '[啤酒]',
    emoji63: '[瓢虫]',
    emoji64: '[勾引]',
    emoji65: '[哦了]',
    emoji66: '[手势]',
    emoji67: '[咖啡]',
    emoji68: '[月亮]',
    emoji69: '[匕首]',
    emoji70: '[发抖]',
    emoji71: '[菜]',
    emoji72: '[拳头]',

    // 2021-03-31
    formulaInfo47: '在日期时间字段中返回小时数',
    formulaInfo48: '在日期时间字段中返回分钟数',
    formulaInfo49: '检查2个定位组件的定位范围是否在300米内，如果不在范围则返回失败消息提示',
    formulaInfo50:
      '销售员打卡=NOT( LOCATION ( 客户地址，销售员打卡地址，300) )，表示销售员打卡地址必须在客户的300米内才允许',
    formulaInfo51:
      "水果分类销售次数=COUNT(CASE WHEN {产品类型}=='水果' THEN {产品编号} ELSE null END)，代表求水果分类的销售次数，不是蔬果分类的返回为0",
    formulaInfo52:
      "客户成交总金额=SUM(CASE WHEN {合同状态}=='已签约' THEN {合同.总金额} ELSE 0 END)",
    formulaInfo53:
      "会员平均消费=AVG（CASE WHEN {会员状态}=='会员' THEN {销售订单.金额} ELSE 0 END）",
    stopMember: '停用人员'
  }
}
